import { gengql } from '@/__generated__';
import { CollectionType } from '@/reducers/appNotifications';
import { AppThunk } from '@/store';

import ActionTypes from './ActionTypes';

const { APP_NOTIFICATION__LIST, APP_NOTIFICATION__REMOVE } = ActionTypes;

// The fields the dashboard's notifications render (AppNotifications).
export const APP_NOTIFICATION_FIELDS = gengql(/* GraphQL */ `
  fragment AppNotificationFields on AppNotification {
    id
    service
    code
    created_at
    read_at
    dismissed_at
    payload {
      ... on NetworkExpertAcceptedInvitationAppNotificationPayload {
        profile {
          id
          name
          url_endpoint
          html_url
          picture_url
        }
        group {
          id
        }
      }
      ... on GroupMemberAwaitingApprovalAppNotificationPayload {
        member {
          id
          group {
            id
            name
            html_url
          }
          user {
            id
            name
            html_url
            picture_url
          }
        }
      }
    }
  }
`);

export function fetchAppNotifications({
  collection = 'default',
}: {
  collection?: CollectionType;
} = {}): AppThunk<Promise<any>> {
  return async (dispatch, getState, { graphql }) => {
    const col = getState().appNotifications[collection];
    if (col) return col;

    // ENG-5506: only the (service, code) pairs AppNotifications renders. Unfiltered, this
    // also returns every engagement notification, which it has no config for and throws on.
    const { internalNetwork, group } = await graphql.query(
      gengql(/* GraphQL */ `
        query actionFetchAppNotifications {
          internalNetwork: appNotifications(
            service: "internal_network"
            code: "expert_accepted_invitation"
          ) {
            ...AppNotificationFields
          }
          group: appNotifications(service: "group", code: "member_awaiting_approval") {
            ...AppNotificationFields
          }
        }
      `)
    );
    const appNotifications = [...(internalNetwork ?? []), ...(group ?? [])];

    dispatch({
      type: APP_NOTIFICATION__LIST,
      collection,
      appNotifications,
    });

    return appNotifications;
  };
}

export function readAppNotifications(ids: any): AppThunk<Promise<any>> {
  return async (_dispatch, _getState, { graphql }) => {
    await graphql.mutate(
      gengql(/* GraphQL */ `
        mutation actionReadAppNotifications($ids: [String]) {
          readAppNotifications(ids: $ids) {
            id
          }
        }
      `),
      { ids }
    );
  };
}

export function dismissAppNotification(id: any): AppThunk<Promise<any>> {
  return async (dispatch, _getState, { graphql }) => {
    const { dismissAppNotification } = await graphql.mutate(
      gengql(/* GraphQL */ `
        mutation actionDismissAppNotification($id: String!) {
          dismissAppNotification(id: $id) {
            id
          }
        }
      `),
      { id }
    );

    dispatch({
      type: APP_NOTIFICATION__REMOVE,
      notificationId: dismissAppNotification!.id,
    });
  };
}
